import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "./Button";
import { SafeHtmlParser } from "./SafeHtmlParser";

const SectionLayout7 = ({
	heading,
	body,
	button,
	colour,
	colour2,
	image1,
	image2,
	image3,
}) => {
	return (
		<section className="py-5 py-lg-7">
			<Container>
				{/* Heading */}
				<Row className="g-5">
					<Col md={6} className="">
						<div style={{ color: colour }} className="mb-lg-7 mb-5">
							<SafeHtmlParser htmlContent={heading} />
						</div>
						{image1 && (
							<div
								style={{
									borderRadius: "12px",
									overflow: "hidden",
									aspectRatio: "1 / 1",
								}}
							>
								<GatsbyImage
									className="h-md-100 h-lg-auto  "
									image={image1}
									alt={heading || "Section Image"}
								/>
							</div>
						)}
					</Col>
					<Col md={6}>
						<Row>
							<Col className="mt-md-9 mt-5" xs={6}>
								{image2 && (
									<div
										style={{
											borderRadius: "12px",
											overflow: "hidden",
											aspectRatio: "1 / 1",
										}}
									>
										<GatsbyImage
											className="h-md-100 h-lg-auto  w-100"
											image={image2}
											alt={heading || "Section Image"}
										/>
									</div>
								)}
							</Col>
							<Col className="mt-md-5" xs={6}>
								{image3 && (
									<div
										style={{
											borderRadius: "12px",
											overflow: "hidden",
											aspectRatio: "1 / 1",
										}}
									>
										<GatsbyImage
											className="h-md-100 h-lg-auto  w-100"
											image={image3}
											alt={heading || "Section Image"}
										/>
									</div>
								)}
							</Col>
						</Row>
						<div className="mt-5 mt-lg-7">
							<SafeHtmlParser htmlContent={body} />
						</div>
						{button && (
							<div className="mt-4">
								<Button
									width="w-100 w-md-auto"
									text={button.title}
									link={button.url}
									colour={colour2 || colour} // Example: purple button
									isOutline={false}
								/>
							</div>
						)}
					</Col>
				</Row>

				{/* Images and Content */}
			</Container>
		</section>
	);
};

export default SectionLayout7;
